import angular from 'angular';

import {
    URL_SIGN_IN,
    URL_SIGN_UP,
    URL_PAYMENT,
    URL_PRIVACY_POLICY,
    URL_TERMS_OF_SERVICE,
    getApplicationStateUrl,
    getLegalStateUrl
} from 'common';

import LandingModule from './landing';

export default angular
    .module('presentation.scene', [
        LandingModule.name
    ])
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider
        .state('sign-in', {
            url: getApplicationStateUrl(URL_SIGN_IN),
            data: {
                external: true
            }
        })
        .state('sign-up', {
            url: getApplicationStateUrl(URL_SIGN_UP),
            data: {
                external: true
            }
        })
        .state('payment', {
            url: getApplicationStateUrl(URL_PAYMENT),
            data: {
                external: true
            }
        })
        .state('privacy-policy', {
            url: getLegalStateUrl(URL_PRIVACY_POLICY),
            data: {
                external: {
                    blank: true
                }
            }
        })
        .state('terms-of-service', {
            url: getLegalStateUrl(URL_TERMS_OF_SERVICE),
            data: {
                external: {
                    blank: true
                }
            }
        });
}



// WEBPACK FOOTER //
// ./src/presentation/scene/index.js